//****************************** Custom List ******************************* */
// GET
export const GET_CUSTOM_LIST_BY_TYPE = "GET_CUSTOM_LIST_BY_TYPE"
export const GET_CUSTOM_LIST_BY_TYPE_SUCCESS = "GET_CUSTOM_LIST_BY_TYPE_SUCCESS"
// PATCH
export const PATCH_CUSTOM_LIST = "PATCH_CUSTOM_LIST"
// POST
export const CREATE_CUSTOM_LIST = "CREATE_CUSTOM_LIST"
